import { Inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { BannerClosedCommand, BannerClosedCommandHandlerBase } from '@skylab-shared/business';
import { HttpService } from '@skylab-shared/core';

@CommandHandlerFor(BannerClosedCommand)
@Injectable({ providedIn: 'root'})
export class BannerClosedCommandHandler {
    private commandHandler: BannerClosedCommandHandlerBase;
    public constructor(
        @Inject(Http) http: HttpService
    ) {
        this.commandHandler = new BannerClosedCommandHandlerBase(http);
    }

    public async handleAsync(cmd: BannerClosedCommand): Promise<void> {
        return await this.commandHandler.handleAsync(cmd);
    }
}
